module.exports = __webpack_public_path__ + "img/area_2.4dbdb13e.png";